import styles from "./CompanyDesc.module.css";
/**
 * @author yjkim
 * @date 2022-10-05 09:55:23
 * @remark 회사소개 페이지 회사 설명
 * @returns <CompanyDesc/>
 */
export function CompanyDesc() {
    return (
        <div className={styles.description_div}>
            <a href="http://www.ksic.net" target="_blank">
                <img className={styles.ksic_logo} src={require("../../img/ksic_logo.png")} alt="한국공간정보통신" />
            </a>
            <div className={styles.description_box}>
                <p className={styles.description_top}>
                    ㈜한국공간정보통신은 20여 년간 연구, 순수 국내기술로 개발한 제품 및 핵심 솔루션을 바탕으로 하여 GIS응용 어플리케이션, ITS, GPS
                    등에 대한 컨설팅 및 시스템 통합 구축사업과 새주소 부여 사업 등 도시 정보화와 시설물 정보화 관련 사업을 수행하고 있습니다.
                </p>
                <p className={styles.description_bottom}>
                    또한 공공부문 사업수행을 통해 인정 받은 기술력 및 신뢰도를 기반으로 민간 부문에도 진출하고 있습니다
                </p>
            </div>
            <a href="/document/brochure/ksic_2020.pdf" className={styles.btn_down_file} download>
                브로슈어 다운로드
            </a>
        </div>
    );
}
